addEventListener("click", function (event) {
    let trigger = event.target as HTMLElement;

    if (trigger.closest('.js-show-hide-trigger')) {
        event.preventDefault();

        const closestStep = trigger.closest('[data-step]');
        const inputs = closestStep?.querySelectorAll<HTMLFormElement>('input[type="radio"], input[type="checkbox"]');
        //const search = closestStep?.querySelector<HTMLElement>('.js-search-autocomplete');

        //if (search != null)
        //    search.value = '';

        if (inputs) {
            inputs.forEach(input => {
                input.dispatchEvent(new Event('change'));
                input.checked = false;
            });
        }

        const closestContent = trigger.closest<HTMLElement>('.js-show-hide-content');
        closestContent?.parentElement?.querySelectorAll('.js-show-hide-content').forEach(sibling => sibling.classList.toggle('is-active'));
    }
});